import React from 'react';
import {useLocalization} from 'localization';
import {useGetUserPreferencesQuery} from 'services/userPreferences';
import {Scene} from 'components/scene';
import {EditShortcuts} from './components/EditShortcuts';

export const ShortcutsScene = () => {
  const {t} = useLocalization();
  const {data} = useGetUserPreferencesQuery('shortcut');

  return (
    <Scene browserTitle={t('appbar.menu.shortcuts')}>
      <Scene.Header title={t('appbar.menu.shortcuts')} />
      <Scene.Content
        loadStatus={data === undefined ? 'Loading' : 'Loaded'}
        loadingType={t('appbar.menu.shortcuts')}>
        <EditShortcuts />
      </Scene.Content>
    </Scene>
  );
};
